import { get } from '../lib'

export type OrganizationFleet = {
  id: number,
  name: string,
  deleteFlag: boolean
}

export type Organization = {
  id: number,
  name: string,
  fleets: OrganizationFleet[],
  deleteFlag: boolean
}

const isRecord = (value: unknown): value is Record<string, unknown> => (
  typeof value === 'object' && value !== null
)

const isOrganizationFleet = (value: unknown): value is OrganizationFleet => {
  if (!isRecord(value)) {
    return false
  }

  return typeof value.id === 'number'
    && typeof value.name === 'string'
    && typeof value.deleteFlag === 'boolean'
}

const isOrganization = (value: unknown): value is Organization => {
  if (!isRecord(value)) {
    return false
  }

  return typeof value.id === 'number'
    && typeof value.name === 'string'
    && Array.isArray(value.fleets)
    && value.fleets.every(isOrganizationFleet)
    && typeof value.deleteFlag === 'boolean'
}

export const formatOrganizationsResponse = (res: unknown): Organization[] => {
  if (!Array.isArray(res) || !res.every(isOrganization)) {
    throw new Error('Invalid organizations response')
  }

  return res
}

export const getOrganizations = async (): Promise<Organization[]> => {
  try {
    const res = await get<unknown>({
      path: '/api/v1/organizations'
    })

    return formatOrganizationsResponse(res)
  } catch (e) {
    console.error('Error fetching organizations', e)
    throw e
  }
}